<template>
  <v-dialog v-model="showModal" persistent max-width="800" :overlay="true">
    <v-card color="blue" class="white--text">
      <v-toolbar tabs>
        <v-toolbar-title id="title">Methods</v-toolbar-title>
      </v-toolbar>
      <catalog :allowAdding="true" v-on:add-method="addMethod"></catalog>
      <v-toolbar tabs>
        <v-spacer></v-spacer>
        <v-btn class="black--text" flat @click.native="$emit('hide-modal')">Close</v-btn>
      </v-toolbar>
    </v-card>
  </v-dialog>
</template>

<script>
import Catalog from '@/components/Catalog/Catalog'
export default {
  components: {
    Catalog
  },
  methods: {
    addMethod(type, obj) {
      this.$emit('add-method', type, obj);
    }
  },
  props: {
    showModal: Boolean
  }
}
</script>




// WEBPACK FOOTER //
// src/components/Workspace/Menus/MethodSelectionModal.vue